import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import LandingPage from "./pages/LandingPage";
import RegistroPage from "./pages/RegistroPage";
import ConfirmacionPage from "./pages/ConfirmacionPage";
import ConsultaPage from "./pages/ConsultaPage";
import AdminPage from "./pages/AdminPage";
import CheckinPage from "./pages/CheckinPage";
import LoginPage from "./pages/LoginPage";
import SalonPage, { SalonDetail } from "./pages/SalonPage";
import SalonPantalla from "./pages/SalonPantalla";
import MonitorPage from "./pages/MonitorPage";
import ContingenciaPage from "./pages/ContingenciaPage";
import CredencialPage from "./pages/CredencialPage";
import ChildCarePage from "./pages/ChildCarePage";
import AdminChildCare from "./pages/AdminChildCare";
import AdminCargaManual from "./pages/AdminCargaManual";
import AdminImportaciones from "./pages/AdminImportaciones";
import AdminHerramientasDatos from "./pages/AdminHerramientasDatos";
import AdminNotificaciones from "./pages/AdminNotificaciones";
import PagosPage from "./pages/PagosPage";
import AdminAsistencia from "./pages/AdminAsistencia";
import AdminLanding from "./pages/AdminLanding";
import AdminLandingPreview from "./pages/AdminLandingPreview";
import AccionSeguraPage from "./pages/AccionSeguraPage";
import { PrintGeneral, PrintCena, PrintTaller, PrintResumen } from "./pages/PrintPages";
import NotFoundPage from "./pages/NotFoundPage";
import { Navigate } from "react-router-dom";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/registro" element={<RegistroPage />} />
          <Route path="/registro/confirmacion/:folio" element={<ConfirmacionPage />} />
          <Route path="/consulta-registro" element={<ConsultaPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/checkin" element={<CheckinPage />} />
          <Route path="/salon" element={<SalonPage />} />
          <Route path="/salon/:workshopId" element={<SalonDetail />} />
          <Route path="/salon/:workshopId/pantalla" element={<SalonPantalla />} />
          <Route path="/monitor" element={<MonitorPage />} />
          <Route path="/contingencia" element={<ContingenciaPage />} />
          <Route path="/admin/reportes" element={<Navigate to="/admin?tab=reportes" replace />} />
          <Route path="/admin/incidencias" element={<Navigate to="/admin?tab=incidencias" replace />} />
          <Route path="/admin/auditoria" element={<Navigate to="/admin?tab=auditoria" replace />} />
          <Route path="/admin/print/evento-general" element={<PrintGeneral />} />
          <Route path="/admin/print/cena" element={<PrintCena />} />
          <Route path="/admin/print/taller/:workshopId" element={<PrintTaller />} />
          <Route path="/admin/print/resumen" element={<PrintResumen />} />
          <Route path="/admin/credencial/:attendeeId" element={<CredencialPage />} />
          <Route path="/cuidado-infantil" element={<ChildCarePage />} />
          <Route path="/admin/cuidado-infantil" element={<AdminChildCare />} />
          <Route path="/admin/carga-manual" element={<AdminCargaManual />} />
          <Route path="/admin/importaciones" element={<AdminImportaciones />} />
          <Route path="/admin/herramientas-datos" element={<AdminHerramientasDatos />} />
          <Route path="/admin/notificaciones" element={<AdminNotificaciones />} />
          <Route path="/pagos" element={<PagosPage />} />
          <Route path="/admin/asistencia" element={<AdminAsistencia />} />
          <Route path="/admin/landing" element={<AdminLanding />} />
          <Route path="/admin/landing/preview" element={<AdminLandingPreview />} />
          <Route path="/a/:token" element={<AccionSeguraPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
